/* Tiloli facets: filter a dropdown's options from the in-panel search box.
   The search box is rendered server-side (snippets/list-filter.liquid, when a filter has > 8 values),
   so it survives Horizon's AJAX morph with no JS injection / observer (no layout jump). This wires
   the live option filtering — and, while searching, reveals options hidden behind "Afficher plus"
   (class `hidden` / `mobile:hidden`), restoring that state when the query is cleared. */
(function () {
  const ITEMS = '.facets__inputs-list-item, .facets__inputs-list > li, .facets__item';
  // requête en cours par filtre (clé = param_name des cases) → ré-appliquée après le morph
  // déclenché par la sélection d'une valeur (l'input est re-rendu vide par Horizon).
  const queries = new Map();
  function panelKey(input) {
    const panel = input.closest('.facets__inputs');
    const cb = panel && panel.querySelector('input[type="checkbox"][name], input[type="radio"][name]');
    return cb ? cb.name : null;
  }

  function cacheOrig(li) {
    if (li.dataset.tlfOrig === undefined) {
      li.dataset.tlfOrig = li.classList.contains('mobile:hidden') ? 'mobile:hidden'
        : li.classList.contains('hidden') ? 'hidden' : '';
    }
    return li.dataset.tlfOrig;
  }

  // Remet le panneau dans son état d'origine. N'agit sur les classes QUE pour les items déjà
  // touchés par une recherche (data-tlfOrig défini) → ne révèle jamais les "Afficher plus" d'un
  // panneau jamais cherché. L'inline display est toujours retiré.
  function restore(panel) {
    if (!panel) return;
    panel.querySelectorAll(ITEMS).forEach((li) => {
      li.style.removeProperty('display');
      if (li.dataset.tlfOrig !== undefined) {
        li.classList.remove('hidden', 'mobile:hidden');
        if (li.dataset.tlfOrig) li.classList.add(li.dataset.tlfOrig);
      }
    });
  }

  function applyFilter(input) {
    const panel = input.closest('.facets__inputs');
    if (!panel) return;
    const q = input.value.trim().toLowerCase();
    const k = panelKey(input);
    if (k) { if (q) queries.set(k, q); else queries.delete(k); }
    if (!q) { restore(panel); return; }
    panel.querySelectorAll(ITEMS).forEach((li) => {
      cacheOrig(li); // mémorise l'état d'origine AVANT de muter
      li.classList.remove('hidden', 'mobile:hidden'); // cherche dans TOUTES les valeurs (incl. "Afficher plus")
      li.style.display = (li.textContent || '').toLowerCase().indexOf(q) !== -1 ? '' : 'none';
    });
  }

  // après un morph (sélection d'une valeur) : réinjecte la requête mémorisée + re-filtre
  function restoreSearches(root) {
    (root || document).querySelectorAll('.tlf-search__input').forEach((input) => {
      const q = queries.get(panelKey(input));
      if (q) { if (input.value !== q) input.value = q; applyFilter(input); }
    });
  }

  document.addEventListener('input', (e) => {
    const input = e.target.closest('.tlf-search__input');
    if (input) applyFilter(input);
  });
  // type="search" : la croix native (×) et Échap émettent `search`, pas toujours `input`
  document.addEventListener('search', (e) => {
    const input = e.target.closest && e.target.closest('.tlf-search__input');
    if (input) applyFilter(input);
  });
  // sortie du filtre (fermeture du <details>) → vide le champ + restaure la liste complète
  document.addEventListener('toggle', (e) => {
    const d = e.target;
    if (!d || d.tagName !== 'DETAILS' || d.open) return;
    const input = d.querySelector('.tlf-search__input');
    if (input) { const k = panelKey(input); if (k) queries.delete(k); input.value = ''; }
    restore(d.querySelector('.facets__inputs'));
  }, true);

  // typing in the search must not toggle the filter <details>
  document.addEventListener('click', (e) => {
    if (e.target.closest('.tlf-search__input')) e.stopPropagation();
  });

  // ---- re-scan prix après morph ----
  // La grille collection est remplacée en AJAX (filtres, infinite scroll) → on ré-émet le hook de
  // re-scan après chaque morph pour que le moteur de prix "own" re-traite les cartes injectées
  // (mêmes évènements que tiloli-feed.js). Markup déjà prêt (.tl-price__net, data-product-id/variant-id).
  function tlNotifyPricing(container) {
    try { document.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true })); } catch (_) {}
    try {
      (container || document).dispatchEvent(new CustomEvent('tl:cards-injected', {
        bubbles: true,
        detail: { container: container, prices: (container || document).querySelectorAll('.tl-price__net') },
      }));
    } catch (_) {}
  }
  const results = document.querySelector('results-list');
  if (results && 'MutationObserver' in window) {
    let t;
    const CARD_SEL = '.product-grid__item, [ref="cards[]"], .tlc';
    // ajout réel de cartes (scroll infini = grid.append)
    const addedCards = (muts) => muts.some((m) => [...m.addedNodes].some((n) =>
      n.nodeType === 1 && (n.matches?.(CARD_SEL) || n.querySelector?.(CARD_SEL))));
    // Filtre = morph EN PLACE (patch attributs/texte, pas d'ajout DOM) → l'observer childList rate.
    // On s'arme sur `filter:update` (émis avant le fetch), puis on tire UNE fois quand le morph se
    // pose (mutations retombées), puis on se désarme → pas de boucle.
    let armed = false;
    document.addEventListener('filter:update', () => { armed = true; });
    // debounce adaptatif : chaque mutation du morph repousse le timer ; on tire UNE fois quand
    // la grille s'arrête de muter (stabilisée), puis on se désarme → pas de double nudge fixe, pas de boucle.
    new MutationObserver((muts) => {
      if (!(armed || addedCards(muts))) return;
      clearTimeout(t);
      t = setTimeout(() => { armed = false; restoreSearches(results); tlNotifyPricing(results); }, 150);
    }).observe(results, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-last-page', 'class', 'aria-busy'] });
  }

  // ---- DEBUG : ouvrir la page collection avec ?tldebug pour tracer le pricing dans la console ----
  if (location.search.indexOf('tldebug') !== -1 && results) {
    const log = (...a) => console.log('%c[TL price]', 'color:#E61E64;font-weight:700', '+' + Math.round(performance.now()) + 'ms', ...a);
    let lastClick = 0, lastScroll = 0, lastMove = 0;
    document.addEventListener('click', () => { lastClick = performance.now(); }, true);
    document.addEventListener('scroll', () => { lastScroll = performance.now(); }, { capture: true, passive: true });
    document.addEventListener('mousemove', () => { lastMove = performance.now(); }, { capture: true, passive: true });
    document.addEventListener('filter:update', () => log('filter:update reçu'));
    // intercepte nos dispatchs
    const orig = tlNotifyPricing;
    tlNotifyPricing = function (c) {
      log('→ on émet tl:cards-injected /', (c || document).querySelectorAll('.tl-price__net').length, 'prix');
      return orig(c);
    };
    const ts = () => {
      const now = performance.now();
      const ago = (t) => (t ? Math.round(now - t) + 'ms' : 'jamais');
      return 'clic:' + ago(lastClick) + ' scroll:' + ago(lastScroll) + ' move:' + ago(lastMove);
    };
    const snap = new WeakMap();
    results.querySelectorAll('.tl-price__net').forEach((n) => snap.set(n, n.textContent.trim()));
    new MutationObserver(() => {
      // montant (texte) injecté/changé
      results.querySelectorAll('.tl-price__net').forEach((n) => {
        const v = n.textContent.trim();
        if (snap.get(n) !== v) { log('✓ montant injecté:', (snap.get(n) || '∅'), '→', v, '|', ts()); snap.set(n, v); }
      });
    }).observe(results, {
      childList: true, subtree: true, characterData: true,
    });
    log('debug actif');
  }
})();
